import styled from "styled-components"

const EventsItemImg = styled.div`
  &::before {
    background-color: ${(props) => props.theme.a_color_gradients.a_dark};
  }
`

const Taxo = styled.span`
  color: ${(props) => props.theme.a_color_gradients.a_light};
`

const StyledDate = styled.div`
  color: ${(props) => props.theme.a_color_gradients.a_light};
`

const Title = styled.h3`
  & > a {
    color: ${(props) => props.theme.a_color_gradients.a_light};
  }
`

export { EventsItemImg, Taxo, Title, StyledDate }
